var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "device" } },
    [
      _vm.isDirtyNFC && _vm.online
        ? _c(
            "el-alert",
            {
              staticClass: "dirty",
              attrs: {
                type: "warning",
                title: _vm.$t("Cuona.Device.NfcUpdate.single_is_dirty"),
                closable: false,
                "show-icon": "",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "warning", size: "mini" },
                  on: { click: _vm.updateNFC },
                },
                [_vm._v(_vm._s(_vm.$t("Cuona.Device.update")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
            {
              name: "visibility-change",
              rawName: "v-visibility-change",
              value: _vm.visibilityChange,
              expression: "visibilityChange",
            },
          ],
          staticClass: "content",
        },
        [
          _vm.device
            ? [
                _c(
                  "div",
                  { staticClass: "device" },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { staticClass: "cuona" }, [
                          _c("img", {
                            attrs: { src: _vm.images[_vm.device.device_type] },
                          }),
                        ]),
                        _c("el-col", { staticClass: "command" }, [
                          _vm.device.device_type === "cube"
                            ? _c("p", { staticClass: "condition" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "statusView",
                                    class: _vm.checkOnLine(_vm.online),
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "status",
                                      class: _vm.checkOnLine(_vm.online),
                                    }),
                                    _vm._v(
                                      _vm._s(_vm.checkOnLineString(_vm.online))
                                    ),
                                  ]
                                ),
                                _c("span", { staticClass: "message" }, [
                                  _vm._v(_vm._s(_vm.showMessage())),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.status !== null && _vm.status.development === 1
                            ? _c("p", { staticClass: "mode" }, [
                                _c("span", { staticClass: "developView" }, [
                                  _c("i", { staticClass: "el-icon-info" }),
                                  _vm._v(
                                    _vm._s(_vm.$t("Cuona.Device.dev_mode"))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "detail" }, [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Cuona.Device.title02", {
                          name: _vm.device.name,
                        })
                      )
                    ),
                    _c(
                      "a",
                      { staticClass: "edit", on: { click: _vm.showDialog } },
                      [
                        _c("i", { staticClass: "el-icon-edit" }),
                        _vm._v(_vm._s(_vm.$t("Cuona.Device.setting"))),
                      ]
                    ),
                  ]),
                  _c("p", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.device.note,
                        expression: "device.note",
                      },
                    ],
                  }),
                  _c(
                    "div",
                    { staticClass: "info" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("span", { staticClass: "item" }, [
                              _vm._v(_vm._s(_vm.$t("Cuona.Device.name"))),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.device.name)),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("span", { staticClass: "item" }, [
                              _vm._v(_vm._s(_vm.$t("Cuona.Device.nfc_uid"))),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.device.nfc_uid)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("span", { staticClass: "item" }, [
                              _vm._v(_vm._s(_vm.$t("Cuona.Device.latlng"))),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.showDeviceLatLon())),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }),
                        ],
                        1
                      ),
                      _vm.status
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("span", { staticClass: "item" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Cuona.Device.firmware_version")
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.status.version)),
                                ]),
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.hasUpdate && !_vm.isUpdating,
                                        expression: "hasUpdate && !isUpdating",
                                      },
                                    ],
                                    staticClass: "edit",
                                    on: { click: _vm.updateFirmwareView },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-warning" }),
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Cuona.Device.update_firmware")
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isUpdating,
                                        expression: "isUpdating",
                                      },
                                    ],
                                    staticClass: "updating",
                                  },
                                  [_c("i", { staticClass: "el-icon-refresh" })]
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("span", { staticClass: "item" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Cuona.Device.touch_sound"))
                                  ),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.showSetSound(_vm.status.set_sound)
                                    )
                                  ),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "edit",
                                    on: { click: _vm.playSoundView },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-bell" }),
                                    _vm._v(
                                      _vm._s(_vm.$t("Cuona.Device.set_touch"))
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.status
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("span", { staticClass: "item" }, [
                                  _vm._v(_vm._s(_vm.$t("Cuona.Device.uptime"))),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.status.uptime)),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("span", { staticClass: "item" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Cuona.Device.temperature"))
                                  ),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.status.temperature) + " ℃"),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.status
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("span", { staticClass: "item" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Cuona.Device.humidity"))
                                  ),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.status.humidity) + " %"),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("span", { staticClass: "item" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Cuona.Device.pressure"))
                                  ),
                                ]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.status.pressure) + " hPa"),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          0 < _vm.device.groups.length
                            ? _c("el-col", { attrs: { span: 12 } }, [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(_vm.$t("Cuona.Device.group_name"))
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "groups" },
                                  [
                                    _vm._l(_vm.device.groups, function (group) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "group",
                                            attrs: {
                                              to: {
                                                path:
                                                  "/cuona/group/" + group.id,
                                              },
                                            },
                                          },
                                          [
                                            _c("h4", [
                                              _vm._v(_vm._s(group.name)),
                                            ]),
                                            _c(
                                              "p",
                                              { staticClass: "manager" },
                                              [
                                                _c("img", {
                                                  staticClass: "thumb",
                                                  attrs: {
                                                    src: _vm.isEmptyImg(
                                                      group.manager.thumb_url
                                                    ),
                                                  },
                                                }),
                                                _vm._v(
                                                  _vm._s(group.manager.name)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    }),
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                          0 < _vm.device.events.length
                            ? _c("el-col", { attrs: { span: 12 } }, [
                                _c("h3", [
                                  _vm._v(_vm._s(_vm.$t("Cuona.Device.events"))),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "events" },
                                  [
                                    !_vm.device.events
                                      ? [
                                          _c("div", { staticClass: "event" }, [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Cuona.Device.unsetting"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      : [
                                          _vm._l(
                                            _vm.device.events,
                                            function (event, index) {
                                              return [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass: "event",
                                                    class: event.action_type,
                                                    attrs: {
                                                      to: {
                                                        path:
                                                          "/cuona/event/" +
                                                          event.id,
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "type",
                                                      attrs: {
                                                        src: _vm.showActionIcon(
                                                          event.action_type
                                                        ),
                                                      },
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(event.name)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            }
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: _vm.$t("Cuona.Device.title03"),
                      visible: _vm.isShowingDialog,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.isShowingDialog = $event
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "input-form" },
                      [
                        _c("label", { staticClass: "caution" }, [
                          _vm._v(_vm._s(_vm.$t("Cuona.Device.name"))),
                        ]),
                        _c("el-input", {
                          staticClass: "label",
                          attrs: {
                            placeholder: _vm.$t("Cuona.Device.message01"),
                          },
                          model: {
                            value: _vm.updateDeviceDialog.deviceName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.updateDeviceDialog,
                                "deviceName",
                                $$v
                              )
                            },
                            expression: "updateDeviceDialog.deviceName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "input-form" },
                      [
                        _c("label", { staticClass: "double" }, [
                          _vm._v(_vm._s(_vm.$t("Cuona.Device.latlng"))),
                        ]),
                        _c("el-input", {
                          staticClass: "lat",
                          attrs: { placeholder: _vm.$t("Cuona.Device.lat") },
                          model: {
                            value: _vm.updateDeviceDialog.lat,
                            callback: function ($$v) {
                              _vm.$set(_vm.updateDeviceDialog, "lat", $$v)
                            },
                            expression: "updateDeviceDialog.lat",
                          },
                        }),
                        _c("el-input", {
                          staticClass: "lon",
                          attrs: { placeholder: _vm.$t("Cuona.Device.lon") },
                          model: {
                            value: _vm.updateDeviceDialog.lon,
                            callback: function ($$v) {
                              _vm.$set(_vm.updateDeviceDialog, "lon", $$v)
                            },
                            expression: "updateDeviceDialog.lon",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer",
                      },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.isShowingDialog = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Cuona.Device.cancel")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.doneDeviceUpdate },
                          },
                          [_vm._v(_vm._s(_vm.$t("Cuona.Device.dochange")))]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: _vm.$t("Cuona.Device.title07"),
                      visible: _vm.isShowingFirmwareDialog,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.isShowingFirmwareDialog = $event
                      },
                    },
                  },
                  [
                    _vm.hasUpdate && _vm.status
                      ? [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("Cuona.Device.description09"))
                            ),
                          ]),
                          _c("p", { staticClass: "version" }, [
                            _c("span", { staticClass: "oldVersion" }, [
                              _vm._v(_vm._s(_vm.status.version)),
                            ]),
                            _c("i", { staticClass: "el-icon-back rightarrow" }),
                            _c("span", { staticClass: "newVersion" }, [
                              _vm._v(_vm._s(this.company.firmware.version)),
                            ]),
                          ]),
                        ]
                      : [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("Cuona.Device.description10"))
                            ),
                          ]),
                        ],
                    _c(
                      "span",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer",
                      },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.isShowingFirmwareDialog = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Cuona.Device.cancel")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.hasUpdate,
                                expression: "hasUpdate",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: { click: _vm.startUpdate },
                          },
                          [_vm._v(_vm._s(_vm.$t("Cuona.Device.update")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _c(
                  "el-dialog",
                  {
                    staticClass: "soundDialog",
                    attrs: {
                      title: _vm.$t("Cuona.Device.title06"),
                      visible: _vm.isShowingPlaySoundDialog,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.isShowingPlaySoundDialog = $event
                      },
                      close: _vm.closePlaySoundDialog,
                    },
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "playSoundDialogForm",
                        attrs: {
                          "label-position": "left",
                          model: _vm.playSoundDialogForm,
                        },
                      },
                      [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Cuona.Device.description04", {
                                name: _vm.device.name,
                              })
                            )
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "choiceSound",
                            on: { change: _vm.resetPlaySoundDialog },
                            model: {
                              value: _vm.playSoundDialogForm.soundId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.playSoundDialogForm,
                                  "soundId",
                                  $$v
                                )
                              },
                              expression: "playSoundDialogForm.soundId",
                            },
                          },
                          _vm._l(_vm.options, function (item) {
                            return _c(
                              "el-option",
                              {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              },
                              [
                                _vm._v(_vm._s(item.label)),
                                item.default
                                  ? _c("i", {
                                      staticClass: "el-icon-bell selected",
                                    })
                                  : _vm._e(),
                              ]
                            )
                          }),
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "volume" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("Cuona.Device.volume"))),
                            ]),
                            _c("el-slider", {
                              model: {
                                value: _vm.playSoundDialogForm.volume,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.playSoundDialogForm,
                                    "volume",
                                    $$v
                                  )
                                },
                                expression: "playSoundDialogForm.volume",
                              },
                            }),
                            _c("span", { staticClass: "volume_value" }, [
                              _vm._v(_vm._s(_vm.playSoundDialogForm.volume)),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { disabled: _vm.playBtnEnabled },
                            on: {
                              click: function ($event) {
                                return _vm.playSound(
                                  _vm.playSoundDialogForm.soundId
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Cuona.Device.play_sound")))]
                        ),
                        _vm.playSoundDialogForm.soundId == 2
                          ? [
                              _c(
                                "transition",
                                { attrs: { name: "fade" } },
                                [
                                  _vm.playSoundDialogForm.isShowingUploader
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "upload",
                                          attrs: {
                                            action: "",
                                            "auto-upload": false,
                                            "on-change": _vm.setCustomAudio,
                                            "show-file-list": false,
                                            drag: "",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-upload",
                                          }),
                                          _c("div", {
                                            staticClass: "el-upload__text",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "Cuona.Device.description07"
                                                )
                                              ),
                                            },
                                          }),
                                          _c("div", {
                                            staticClass: "el-upload__tip",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "Cuona.Device.description08"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm.playSoundDialogForm.isShowingUploading
                                ? _c("p", [
                                    _c("i", { staticClass: "el-icon-loading" }),
                                    _c("span", { staticClass: "uploading" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("Cuona.Device.uploading"))
                                      ),
                                    ]),
                                  ])
                                : _vm.playSoundDialogForm.isShowingUploaded
                                ? _c(
                                    "div",
                                    [
                                      _c("p", { staticClass: "success" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Cuona.Device.complete_upload"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: _vm.resetPlaySoundDialog,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-upload",
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Cuona.Device.reopen_uploader"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer",
                      },
                      [
                        _c(
                          "el-button",
                          { on: { click: _vm.closePlaySoundDialog } },
                          [_vm._v(_vm._s(_vm.$t("Cuona.Device.close")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "setting",
                            attrs: {
                              type: "primary",
                              disabled: _vm.playBtnEnabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setTouchSound(
                                  _vm.playSoundDialogForm.soundId,
                                  50
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Cuona.Device.set_sound")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }